"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12 13.5a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.5.5m-.5 2a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M11.997 3.997a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
  })]
}), 'ErrorCircle');
